export default __webpack_public_path__ + "static/media/IMG-20240729-WA0002.15dca621.jpg";